import { Swal, Inputmask, Fancybox } from "./vendor";
import {
  ajaxErrorAlert,
  ajaxPost,
  parceAjaxErrorResponse,
  toggleBetweenElements,
} from "./js/utils";
import { bsToast, bsModal } from "./js/plugins";
import { Tooltip, Dropdown } from "bootstrap";
import Swiper from "swiper/bundle";

let translations = {};
const translationsJson = $("#translations");
if (translationsJson.length > 0) {
  translations = JSON.parse(translationsJson.text());
}

let jsContext = {};
const jsContextJson = $("#js_context");
if (jsContextJson.length > 0) {
  jsContext = JSON.parse(jsContextJson.text());
}

export const alis_ajax_object = window["alis_ajax_object"],
  ajax_url = alis_ajax_object["ajax_url"],
  ajax_security = alis_ajax_object["security"],
  payment_page_url = alis_ajax_object["payment_page_url"],
  site_url = alis_ajax_object["site_url"],
  site_lang = alis_ajax_object["site_lang"];

export const getJsContext = (key) => {
  if (!(key in jsContext)) {
    return key;
  }
  return jsContext[key];
};

export const getTranslation = (key) => {
  if (!(key in translations)) {
    return key;
  }
  return translations[key];
};

export const getUrlTranslation = (url) => {
  const lang = document.querySelector("html").getAttribute("lang");
  if (lang === "az") {
    return url;
  }

  return `/${lang}${url}`;
};

export const WimsSwal = Swal.mixin({
  customClass: {
    title: "ms-2",
    actions: "ps-2",
    confirmButton: "btn btn-primary px-5 m-2",
    cancelButton: "btn btn-secondary px-5 m-2",
    denyButton: "btn btn-secondary px-5 m-2",
  },
  buttonsStyling: false,
  heightAuto: false,
});

export const SwalPost = (url, data, options = {}) => {
  return new Promise((resolve, reject) => {
    WimsSwal.fire({
      text: getTranslation("are_you_sure_to_perform_this_action"),
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: getTranslation("yes_perform"),
      cancelButtonText: getTranslation("no_cancel"),
      heightAuto: false,
      ...options,
    }).then((result) => {
      if (result.isConfirmed) {
        ajaxPost(url, data)
          .then((response) => {
            resolve(response);
          })
          .catch((errors) => {
            const errorList = parceAjaxErrorResponse(errors);
            ErrorSwal.fire({ html: errorList.join("<br>") }).then(() => {
              reject(errors);
            });
          });
      } else {
        reject('Swal: "Xeyr, imtina" düyməsinə basıldı');
      }
    });
  });
};

export const Toast = Swal.mixin({
  toast: true,
  position: "top-end",
  showConfirmButton: false,
  buttonsStyling: false,
  timer: 3000,
  timerProgressBar: true,
  customClass: {
    title: "ms-2",
    actions: "ps-2",
    confirmButton: "btn btn-primary px-5 m-2",
    cancelButton: "btn btn-secondary px-5 m-2",
    denyButton: "btn btn-secondary px-5 m-2",
  },
  didOpen: (toast) => {
    toast.addEventListener("mouseenter", Swal.stopTimer);
    toast.addEventListener("mouseleave", Swal.resumeTimer);
    toast.addEventListener("click", Swal.close);
  },
});

export const SuccessSwal = WimsSwal.mixin({
  icon: "success",
  text: getTranslation("operation_successfully_performed"),
});

export const ErrorSwal = WimsSwal.mixin({
  icon: "error",
  titleText: getTranslation("error_occurred"),
  text: getTranslation("error_occurred_on_request_to_server"),
});

export const AlertSwal = WimsSwal.mixin({
  showCancelButton: true,
  confirmButtonText: getTranslation("yes_perform"),
  cancelButtonText: getTranslation("no_cancel"),
});

export const SuccessToast = WimsSwal.mixin({
  // title: 'Əla!',
  text: getTranslation("operation_successfully_performed"),
  icon: "success",
  toast: true,
  position: "bottom-end",
  showConfirmButton: false,
  timer: 3000,
  timerProgressBar: true,
  didOpen: (toast) => {
    toast.addEventListener("mouseenter", Swal.stopTimer);
    toast.addEventListener("mouseleave", Swal.resumeTimer);
    toast.addEventListener("mouseclick", Swal.close);
  },
});

function stickyHeader() {
  const scrollTop = $("html").scrollTop();
  const header = $(".main-header");
  const headerCopied = $(".main-header.main-header-copy");
  const activateStickyFrom = 150;

  if (scrollTop > activateStickyFrom && headerCopied.length === 0) {
    let headerCopy = header.clone();
    headerCopy.removeClass("fixed");
    headerCopy.addClass("main-header-copy");
    headerCopy.insertAfter(".main-header");
  }

  if (scrollTop > activateStickyFrom) {
    headerCopied.addClass("main-header-sticky");
  } else {
    headerCopied.removeClass("main-header-sticky");
    const dropdownElementList = [].slice.call(
      document.querySelectorAll(".dropdown-toggle"),
    );
    const dropdownList = dropdownElementList.map(function (dropdownToggleEl) {
      return new Dropdown(dropdownToggleEl);
    });
    dropdownList.forEach((dropdown) => {
      dropdown.hide();
      $(".hamburger").removeClass("is-active");
      $(".hamburger-menu").removeClass("show");
    });
  }
}

stickyHeader();
$(window).scroll(function () {
  stickyHeader();
});

// initialize jquery plugins
// use this function to initialize plugins after ajax calls (for example after modal content loaded)
export const initPlugins = (parent = null) => {
  if (!parent) {
    parent = $("body");
  } else {
    parent = $(parent);
  }

  parent
    .find(".select2")
    .select2({
      minimumResultsForSearch: -1,
      placeholder: {
        id: "",
        text: getJsContext("select_one"),
      },
    })
    .on("select2:open", function (e) {
      $(".select2-dropdown").hide();
      setTimeout(function () {
        $(".select2-dropdown").addClass("select2-animate-open").show();
      });
    });

  parent.find(".form-control-datepicker").flatpickr({
    dateFormat: "d.m.Y",
    allowInput: true,
    disableMobile: true,
    // enableTime: true,
    time_24hr: true,
    // inline: true,
  });

  parent.find(".form-control-inline-datepicker").flatpickr({
    dateFormat: "d.m.Y",
    allowInput: true,
    disableMobile: true,
    // enableTime: true,
    time_24hr: true,
    inline: true,
    mode: "range",
  });

  parent.find(".form-control-timepicker").flatpickr({
    enableTime: true,
    noCalendar: true,
    dateFormat: "H:i:ss",
    time_24hr: true,
  });

  parent.find(".form-control-datetimepicker").flatpickr({
    enableTime: true,
    dateFormat: "d.m.Y H:i",
    time_24hr: true,
  });

  parent.find(".form-control-range-datepicker").flatpickr({
    dateFormat: "d.m.Y",
    allowInput: true,
    mode: "range",
    locale: {
      rangeSeparator: " - ",
    },
  });

  parent.find('[data-bs-toggle="tooltip"]').each((_, el) => {
    new Tooltip(el);
  });
};
initPlugins();

$("body")
  .find('[data-bs-toggle="tooltip"]')
  .each((_, el) => {
    new Tooltip(el);
  });

$(".filter-change-button-notyet").on("click", (e) => {
  e.preventDefault();
  const currentButton = $(e.currentTarget);
  const buttons = $(".filter-change-button");
  const currentForm = $(".filter-form.filter-form-active");
  const nextForm = $(currentButton.data("form"));

  buttons.attr("style", "pointer-events: none");
  buttons.removeClass("filter-change-button-active");
  currentButton.addClass("filter-change-button-active");

  currentForm.removeClass("filter-form-active");
  nextForm.addClass("filter-form-active");

  toggleBetweenElements(currentForm, nextForm, 300, () => {
    buttons.attr("style", "pointer-events: auto");
  });
});

const swiper = new Swiper(".testimonials-swiper", {
  // Optional parameters
  direction: "vertical",
  // loop: true,

  pagination: {
    el: ".testimonials-swiper-pagination",
    type: "bullets",
    verticalClass: "swiper-pagination-horizontal",
  },

  // Navigation arrows
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
});

$(".search-filter-form-button").on("click", (e) => {
  e.preventDefault();
  $(".header-top-search-form").fadeIn(200);
});

$(".header-top-search-form button[type=button]").on("click", (e) => {
  $(".header-top-search-form").fadeOut(200);
});

Fancybox.bind("[data-fancybox]", {
  // Your custom options
});

$(document).on("submit", "#contactUsForm", function (e) {
  e.preventDefault();

  const submitButton = $(this).find(".btn");
  submitButton.attr("disabled", true);

  const formData = $(this).serializeArray();

  const data = {
    action: "contact_us",
    security: ajax_security,
    site_lang,
    ...formData.reduce((acc, data) => {
      acc = {
        ...acc,
        [data.name]: data.value,
      };

      return acc;
    }, {}),
  };

  jQuery.post(
    ajax_url,
    data,
    function (response) {
      if (response.success === true) {
        Swal.fire({
          titleText: null,
          text: response.data,
          icon: "success",
          confirmButtonText: "OK",
        }).then(function () {
          window.location.reload();
        });
      } else {
        ErrorSwal.fire({
          titleText: null,
          text: response.data,
          icon: "error",
          dangerMode: true,
          confirmButtonText: "OK",
        });
        submitButton.attr("disabled", false);
      }
    },
    "json",
  );
});

$(document).on("submit", "#requestTourForm", function (e) {
  e.preventDefault();

  const submitButton = $(this).find(".btn");
  submitButton.attr("disabled", true);

  const formData = $(this).serializeArray();

  const data = {
    action: "request_tour_price",
    security: ajax_security,
    site_lang,
    ...formData.reduce((acc, data) => {
      acc = {
        ...acc,
        [data.name]: data.value,
      };

      return acc;
    }, {}),
  };

  jQuery.post(
    ajax_url,
    data,
    function (response) {
      if (response.success === true) {
        Swal.fire({
          titleText: null,
          text: response.data,
          icon: "success",
          confirmButtonText: "OK",
        }).then(function () {
          window.location.reload();
        });
      } else {
        ErrorSwal.fire({
          titleText: null,
          text: response.data,
          icon: "error",
          dangerMode: true,
          confirmButtonText: "OK",
        });
        submitButton.attr("disabled", false);
      }
    },
    "json",
  );
});

$("select.tour-countries").on("change", function () {
  const country = $(this).val();
  const citySelect = $("select.tour-cities");

  citySelect.prop("disabled", true);
  citySelect.html('<option value="">' + getJsContext("loading") + "</option>");

  $.ajax({
    url: ajax_url,
    method: "POST",
    data: {
      action: "get_tour_cities_by_country",
      security: ajax_security,
      country: country,
      site_lang: site_lang,
    },
    dataType: "json",
    success: function (response) {
      if (response.success) {
        citySelect.html(response["data"]);
        citySelect.prop("disabled", false);
      } else {
        citySelect.prop("disabled", false);
      }
    },
    error: function () {
      citySelect.html(
        '<option value="">' +
          getJsContext("error_loading_cities") +
          "</option>",
      );
    },
  });
});

$("select.hotel-countries").on("change", function () {
  const country = $(this).val();
  const citySelect = $("select.hotel-cities");

  citySelect.prop("disabled", true);
  citySelect.html('<option value="">' + getJsContext("loading") + "</option>");

  $.ajax({
    url: ajax_url,
    method: "POST",
    data: {
      action: "get_hotel_cities_by_country",
      security: ajax_security,
      country: country,
      site_lang: site_lang,
    },
    dataType: "json",
    success: function (response) {
      if (response.success) {
        citySelect.html(response["data"]);
        citySelect.prop("disabled", false);
      } else {
        citySelect.prop("disabled", false);
      }
    },
    error: function () {
      citySelect.html(
        '<option value="">' +
          getJsContext("error_loading_cities") +
          "</option>",
      );
    },
  });
});

$("select.congress-hall-countries").on("change", function () {
  const country = $(this).val();
  const citySelect = $("select.congress-hall-cities");

  citySelect.prop("disabled", true);
  citySelect.html('<option value="">' + getJsContext("loading") + "</option>");

  $.ajax({
    url: ajax_url,
    method: "POST",
    data: {
      action: "get_congress_hall_cities_by_country",
      security: ajax_security,
      country: country,
      site_lang: site_lang,
    },
    dataType: "json",
    success: function (response) {
      if (response.success) {
        citySelect.html(response["data"]);
        citySelect.prop("disabled", false);
      } else {
        citySelect.prop("disabled", false);
      }
    },
    error: function () {
      citySelect.html(
        '<option value="">' +
          getJsContext("error_loading_cities") +
          "</option>",
      );
    },
  });
});

$("select.restaurant-countries").on("change", function () {
  const country = $(this).val();
  const citySelect = $("select.restaurant-cities");

  citySelect.prop("disabled", true);
  citySelect.html('<option value="">' + getJsContext("loading") + "</option>");

  $.ajax({
    url: ajax_url,
    method: "POST",
    data: {
      action: "get_restaurant_cities_by_country",
      security: ajax_security,
      country: country,
      site_lang: site_lang,
    },
    dataType: "json",
    success: function (response) {
      if (response.success) {
        citySelect.html(response["data"]);
        citySelect.prop("disabled", false);
      } else {
        citySelect.prop("disabled", false);
      }
    },
    error: function () {
      citySelect.html(
        '<option value="">' +
          getJsContext("error_loading_cities") +
          "</option>",
      );
    },
  });
});

$("select.event-hall-countries").on("change", function () {
  const country = $(this).val();
  const citySelect = $("select.event-hall-cities");

  citySelect.prop("disabled", true);
  citySelect.html('<option value="">' + getJsContext("loading") + "</option>");

  $.ajax({
    url: ajax_url,
    method: "POST",
    data: {
      action: "get_event_hall_cities_by_country",
      security: ajax_security,
      country: country,
      site_lang: site_lang,
    },
    dataType: "json",
    success: function (response) {
      if (response.success) {
        citySelect.html(response["data"]);
        citySelect.prop("disabled", false);
      } else {
        citySelect.prop("disabled", false);
      }
    },
    error: function () {
      citySelect.html(
        '<option value="">' +
          getJsContext("error_loading_cities") +
          "</option>",
      );
    },
  });
});

$("select.place-to-visit-countries").on("change", function () {
  const country = $(this).val();
  const citySelect = $("select.place-to-visit-cities");

  citySelect.prop("disabled", true);
  citySelect.html('<option value="">' + getJsContext("loading") + "</option>");

  $.ajax({
    url: ajax_url,
    method: "POST",
    data: {
      action: "get_places_to_visit_cities_by_country",
      security: ajax_security,
      country: country,
      site_lang: site_lang,
    },
    dataType: "json",
    success: function (response) {
      if (response.success) {
        citySelect.html(response["data"]);
        citySelect.prop("disabled", false);
      } else {
        citySelect.prop("disabled", false);
      }
    },
    error: function () {
      citySelect.html(
        '<option value="">' +
          getJsContext("error_loading_cities") +
          "</option>",
      );
    },
  });
});

if ($(".mice-swiper").length > 0) {
  const miceSwiper = new Swiper(".mice-swiper", {
    // Optional parameters
    direction: "horizontal",
    loop: true,
    slidesPerView: 1,
    spaceBetween: 30,
    autoplay: {
      delay: 4500,
      disableOnInteraction: false,
    },
    breakpoints: {
      // when window width is >= 320px
      320: {
        slidesPerView: 1,
        spaceBetween: 10,
      },
      // when window width is >= 640px
      640: {
        slidesPerView: 2,
        spaceBetween: 20,
      },
      992: {
        slidesPerView: 3,
        spaceBetween: 30,
      },
    },
    // Navigation arrows
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
  });
}

if ($(".tour-swiper").length > 0) {
  const miceSwiper = new Swiper(".tour-swiper", {
    // Optional parameters
    direction: "horizontal",
    loop: true,
    slidesPerView: 4,
    spaceBetween: 20,
    autoplay: {
      delay: 4500,
      disableOnInteraction: false,
    },
    breakpoints: {
      // when window width is >= 320px
      320: {
        slidesPerView: 2,
        spaceBetween: 10,
      },
      // when window width is >= 640px
      640: {
        slidesPerView: 3,
        spaceBetween: 15,
      },
      992: {
        slidesPerView: 4,
        spaceBetween: 20,
      },
    },
    // Navigation arrows
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
  });
}

$(document).on("submit", "#bookHotelForm", function (e) {
  e.preventDefault();

  const submitButton = $(this).find(".btn");
  submitButton.attr("disabled", true);

  const formData = $(this).serializeArray();

  const data = {
    action: "book_hotel",
    security: ajax_security,
    site_lang,
    ...formData.reduce((acc, data) => {
      acc = {
        ...acc,
        [data.name]: data.value,
      };

      return acc;
    }, {}),
  };

  jQuery.post(
    ajax_url,
    data,
    function (response) {
      if (response.success === true) {
        Swal.fire({
          titleText: null,
          text: response.data,
          icon: "success",
          confirmButtonText: "OK",
        }).then(function () {
          window.location.reload();
        });
      } else {
        ErrorSwal.fire({
          titleText: null,
          text: response.data,
          icon: "error",
          dangerMode: true,
          confirmButtonText: "OK",
        });
        submitButton.attr("disabled", false);
      }
    },
    "json",
  );
});

$(".desctiptionOfThePaymentModalBtn").on("click", (e) => {
  e.preventDefault();

  const desctiptionOfThePaymentModal = bsModal("medium", {
    modalId: "desctiptionOfThePaymentModal",
    backdrop: "none",
  });

  ajaxPost(ajax_url, {
    action: "description_of_the_payment_process_modal",
    security: ajax_security,
  })
    .then((response) => {
      $(desctiptionOfThePaymentModal).modal("content", response.data["html"]);
    })
    .catch((errors) => {
      ErrorSwal.fire({
        html: parceAjaxErrorResponse(errors).join("<br>"),
      }).then(() => {
        $(desctiptionOfThePaymentModal).modal("hide");
      });
    });
});
$(".refundPolicyModalBtn").on("click", (e) => {
  e.preventDefault();

  const refundPolicyModalModal = bsModal("medium", {
    modalId: "refundPolicyModalModal",
    backdrop: "none",
  });

  ajaxPost(ajax_url, {
    action: "refund_policy_modal",
    security: ajax_security,
  })
    .then((response) => {
      $(refundPolicyModalModal).modal("content", response.data["html"]);
    })
    .catch((errors) => {
      ErrorSwal.fire({
        html: parceAjaxErrorResponse(errors).join("<br>"),
      }).then(() => {
        $(refundPolicyModalModal).modal("hide");
      });
    });
});
